import React from 'react'
import * as SurveyJS from 'survey-react'

import DatePickerWrapper from './datePickerWrapper'

const DatePickerWidget = {
  name: 'datepickerwidget',
  title: 'datepickerwidget',
  iconName: 'icon-default',
  widgetIsLoaded: function() {
    return true
  },
  isFit: function(question) {
    switch (question.name) {
      case 'Xplor_ChildDOB':
        return true
      case 'XplorRequired_IntendedStartDate':
        return true
      case 'Xplor_PCDOB':
        return true
      case 'Xplor_ACDOB':
        return true
      default:
        return false
    }
  },
  activatedByChanged: function() {
    SurveyJS.JsonObject.metaData.addClass('datepickerwidget', [], null, 'text')
  },
  // eslint-disable-next-line react/display-name
  render: question => {
    return <DatePickerWrapper question={question} />
  }
}

export default DatePickerWidget
